import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';

const BrandedCTAContainer = styled.div`
    .cta-wrapper {
        display: flex;
        ${media.medium` align-items: center; max-width: 100vw;`}

        padding: 70px 0;
        .col {
            flex: 1;

            &.col-right {
                flex: 1.5;
                display: none;

                ${media.large`display: block;`}
                .gatsby-image-wrapper {
                    right: -5vw;
                    top: -20vh;
                    margin-bottom: -20vh;
                    max-width: 400px;
                    margin-left: auto;
                    ${media.large`max-width: 100%;`}
                }
            }

            &.col-center {
                .inner-wrap {
                    text-align: center;

                    h3 {
                        font-size: 2.5rem;
                        color: #000;
                        font-family: neue-kabel, sans-serif;
                        font-weight: 800;
                        max-width: 530px;
                        margin: 0 auto 20px;
                    }

                    p {
                        font-size: 1rem;
                        color: #000;
                        margin: 0 0 30px;
                        line-height: 1.5;
                    }

                    .btn-container {
                        a {
                            color: #fff;
                            background-color: #f74d33;
                            font-weight: 800;
                            font-family: neue-kabel, sans-serif;
                            text-decoration: none;
                            padding: 20px 30px;
                            box-shadow: 0px 10px 12px rgba(0, 0, 0, 0.12);
                            border-radius: 5px;
                            font-size: 1rem;
                            display: inline-block;
                            border: 1px solid #f74d33;
                            ${TransitionMixin('.25s')}

                            &:hover {
                                background-color: transparent;
                                color: #f74d33;
                            }
                        }
                    }
                }
            }

            &.col-left {
                flex: 1.5;
                display: none;

                ${media.large`display: block;`}
                .gatsby-image-wrapper {
                    left: -5vw;
                    top: -20vh;
                    margin-bottom: -20vh;
                    max-width: 400px;
                    ${media.large`max-width: 100%;`}
                }
            }
        }
    }
`;

const BrandedCTA = ({ content }) => {
    const { leftImage, rightImage, ctaDescription, ctaTitle, ctaButton } =
        content || {};
    return (
        <BrandedCTAContainer>
            <Wrapper className="cta-wrapper">
                <div className="col col-left">
                    <Img fluid={leftImage.localFile.childImageSharp.fluid} />
                </div>
                <div className="col col-center">
                    <div className="inner-wrap">
                        <h3>{ctaTitle}</h3>
                        <p>{ctaDescription}</p>
                        <div className="btn-container">
                            <Link to={ctaButton.url}>{ctaButton.title}</Link>
                        </div>
                    </div>
                </div>
                <div className="col col-right">
                    <Img fluid={rightImage.localFile.childImageSharp.fluid} />
                </div>
            </Wrapper>
        </BrandedCTAContainer>
    );
};

export default BrandedCTA;
